import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogTitle } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import usePrintAddress from 'api/locationsCategories/address/usePrintAddress';
import usePrintAddresses from 'api/locationsCategories/address/usePrintAddresses';
import React, { useEffect, useRef } from 'react';
// import ReactToPrint from 'react-to-print';
import { useReactToPrint } from 'react-to-print';

import PrintCard from './PrintCard';

const PrintModal = props => {
  const { guid, addressGuid, rootPrints, type } = props;
  const refElement = useRef(null);
  const printRef = useRef(null);

  const reactToPrintFn = useReactToPrint({
    contentRef: refElement,
  });

  const [printLoading, printData, setPrintData, getPrintData] =
    usePrintAddress();
  const [printsLoading, printsData, setPrintsData, getPrintsData] =
    usePrintAddresses();

  useEffect(() => {
    if (props.show) {
      handleLoadData();
    }
  }, [props.show]);

  function handleLoadData() {
    if (!rootPrints) {
      getPrintData(addressGuid);
    } else {
      getPrintsData(guid, type);
    }
  }

  const handleClick = () => {
    // printRef?.current.();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Dialog
      open={props.show}
      onClose={props.closeHandler}
      sx={{ direction: 'rtl' }}
      maxWidth="xs"
      fullWidth
      onKeyDown={handleKeyDown}
    >
      <DialogTitle sx={{ boxShadow: '1', py: '10px' }}>پرینت</DialogTitle>

      <DialogContent
        sx={{
          padding: '20px 15px !important',
        }}
      >
        {rootPrints && !!printsData ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              direction: 'ltr',
            }}
          >
            <Box
              ref={refElement}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                direction: 'ltr',
                gap: '12px',
              }}
            >
              {printsData.map((d, index) => (
                <PrintCard
                  key={d.display}
                  item={d}
                  sx={{
                    pageBreakBefore:
                      index === printsData.length ? 'auto' : 'always',
                  }}
                />
              ))}
            </Box>
          </Box>
        ) : null}

        {!rootPrints && !!printData ? (
          <Box
            ref={refElement}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              direction: 'ltr',
            }}
          >
            <PrintCard item={printData} />
          </Box>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3, py: '10px', boxShadow: '3' }}>
        <LoadingButton
          variant="contained"
          color="primary"
          disabled={false}
          onClick={reactToPrintFn}
          loading={printLoading || printsLoading}
        >
          پرینت
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={() => {
            setPrintData(null);
            setPrintsData(null);
            props.handleClose();
          }}
        >
          بستن
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PrintModal;
